import { LoanResponse, LoanCycleUnit, LoanRateType } from '@/api/model/loan'
import { FundMemberDetail, Debit, FundType, FundMemberDetailRequest } from '@/api/model/cash'
import { RepaymentState, TallyBillState, TallyBillType, PayRequestRecordStatus, ChannelList, RequestType } from '@/api/model/repayment'
import { translate } from './filters'
import dayjs from 'dayjs'

export function transformRate(row: LoanResponse) {
    switch (row.rateType) {
        case LoanRateType.DAY:
            return translate('loan.tableData.rateType.day', { rate: (row.rate / 100).toFixed(2) })
        case LoanRateType.MONTH:
            return translate('loan.tableData.rateType.month', { rate: (row.rate / 100).toFixed(2) })
        case LoanRateType.YEAR:
            return translate('loan.tableData.rateType.year', { rate: (row.rate / 100).toFixed(2) })
        default:
            return translate('loan.tableData.rateType.day', { rate: (row.rate / 100).toFixed(2) })
    }
}

export function transformLoanCycle(row: LoanResponse) {
    switch (row.loanCycleUnit) {
        case LoanCycleUnit.DAY:
            return translate('loan.tableData.loanCycleUnit.day', { loanCycle: row.loanCycle })
        case LoanCycleUnit.MONTH:
            return translate('loan.tableData.loanCycleUnit.month', { loanCycle: row.loanCycle })
        default:
            return translate('loan.tableData.loanCycleUnit.day', { loanCycle: row.loanCycle })
    }
}

export function transformRepaymentState(state: RepaymentState): string {
    switch (state) {
        case RepaymentState.UNPAID:
            return translate('repayment.state.unpaid')
        case RepaymentState.NORMAL:
            return translate('repayment.state.normal')
        case RepaymentState.OVERDUE:
            return translate('repayment.state.overdue')
        case RepaymentState.AFTER_OVERDUE:
            return translate('repayment.state.afterOverdue')
        case RepaymentState.PARTIAL:
            return translate('repayment.state.partial')
        case RepaymentState.AFTER_PARTIAL:
            return translate('repayment.state.afterPartial')
        case RepaymentState.MANUAL:
            return translate('repayment.state.manual')
        case RepaymentState.CANCEL:
            return translate('repayment.state.cancel')
        default:
            return ''
    }
}

export function payRequestRecordStatus(state: PayRequestRecordStatus): string {
    switch (state) {
        case PayRequestRecordStatus.NoHandle:
            return translate('未处理')
        case PayRequestRecordStatus.Processed:
            return translate('已处理')
        case PayRequestRecordStatus.FAIL:
            return translate('处理失败')
        default:
            return ''
    }
}

export function requestType(state: RequestType): string {
    switch (state) {
        case RequestType.REQUEST:
            return translate('请求')
        case RequestType.SEARCH:
            return translate('查询')
        case RequestType.CALL:
            return translate('回调')
        default:
            return ''
    }
}

export function channelList(state: ChannelList): string {
    switch (state) {
        case ChannelList.STP:
            return translate('STP')
        case ChannelList.conektaPay:
            return translate('conektaPay')
        case ChannelList.openPay:
            return translate('openPay')
        default:
            return ''
    }
}

export function tallyBillState(state: TallyBillState): string {
    switch (state) {
        case TallyBillState.WAIT_APPROVE:
            return translate('repayment.tallyBillState.waitApprove')
        case TallyBillState.FINISH_APPROVE:
            return translate('repayment.tallyBillState.finishApprove')
        case TallyBillState.CANCEL_APPROVE:
            return translate('repayment.tallyBillState.cancelApprove')
        default:
            return ''
    }
}

export function tallyBillType(state: TallyBillType): string {
    switch (state) {
        case TallyBillType.INBURSA_REPAYMENT:
            return translate('repayment.tallyBillType.inbursaRepay')
        case TallyBillType.OVERDUE_REPAYMENT:
            return translate('repayment.tallyBillType.overdueRepay')
        default:
            return ''
    }
}

export function Time(timeStamp: string | number, defaultValue = '') {
    if (!timeStamp) return defaultValue
    return dayjs(timeStamp).format('HH:mm:ss')
}
export function Date(timeStamp: string | number, defaultValue = '') {
    if (!timeStamp) return defaultValue
    return dayjs(timeStamp).format('YYYY-MM-DD')
}
export function DateTime(timeStamp: string | number, defaultValue = '') {
    if (!timeStamp) return defaultValue
    return dayjs(timeStamp).format('YYYY-MM-DD HH:mm:ss')
}

export function transformDebit(row: FundMemberDetail) {
    switch (row.debit) {
        case Debit.ADD:
            return '+ ' + row.amount
        case Debit.REDUCE:
            return '- ' + row.amount
        default:
            return ''
    }
}

export function transformFundRemark(row: FundMemberDetail) {
    switch (row.debit) {
        case Debit.ADD:
            return row.remark + ',' + translate('cash.tableData.remark.income') + row.amount
        case Debit.REDUCE:
            return row.remark + ',' + translate('cash.tableData.remark.expenditure') + row.amount
        default:
            return ''
    }
}
